import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import Moment from "moment";
import "moment/locale/id";

function Step5() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  const listJson = pengajuan.getListKategoriJson; // Key yang sudah benar

  Moment.locale("id");
  const tglKeluarJaminan = Moment(
    valDetail.stepLima.tanggalKeluarJaminan,
  ).format("DD MMMM YYYY");

  // FUNGSI MAPPER OTOMATIS
  const getLabel = (category, value) => {
    if (listJson && listJson[category]) {
      const found = listJson[category].find(
        (item) =>
          String(item.value).toLowerCase() === String(value).toLowerCase(),
      );
      return found ? found.label : value || "-";
    }
    return value || "-";
  };

  // KOMPONEN REUSABLE INFO ITEM
  const InfoItem = ({
    label,
    value,
    col = 6,
    isPrimary = false,
    color = "black",
  }) => (
    <Col md={col} className="mb-3">
      <label
        className="text-muted fw-bold mb-1 d-block"
        style={{
          fontSize: "10px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </label>
      <div
        className={`p-2 rounded ${isPrimary ? "bg-light border" : ""}`}
        style={{
          fontSize: "14px",
          fontWeight: isPrimary ? "800" : "600",
          color: color,
          minHeight: "38px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {value || "-"}
      </div>
    </Col>
  );

  return (
    <Row className="mt-3">
      <Col md="12">
        <Card className="border-0 shadow-sm" style={{ borderRadius: "15px" }}>
          <Card.Body className="p-4">
            <div
              style={{
                maxHeight: "550px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
              className="custom-scrollbar pr-2"
            >
              <Row>
                {/* --- SEKSI 1: DETAIL ASET JAMINAN --- */}
                <Col md={12} className="mb-3 mt-2">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Detail Aset Jaminan
                  </h6>
                  <hr className="mt-1" />
                </Col>
                <InfoItem
                  label="Nama Jaminan"
                  value={valDetail.stepLima.namaJaminan}
                  isPrimary
                />
                <InfoItem
                  label="Jenis Jaminan"
                  value={getLabel(
                    "jenisJaminan",
                    valDetail.stepLima.jenisJaminan,
                  )}
                  isPrimary
                />
                <InfoItem
                  label="Nomor Jaminan (SHM/BPKB/SK)"
                  value={valDetail.stepLima.nomorJaminan}
                />
                <InfoItem
                  label="Tanggal Keluar Jaminan"
                  value={tglKeluarJaminan}
                />
                <InfoItem
                  label="Keterangan Jaminan"
                  value={valDetail.stepLima.keteranganJaminan}
                  col={12}
                />

                {/* --- SEKSI 2: KEPEMILIKAN JAMINAN --- */}
                <Col md={12} className="mb-3 mt-4">
                  <h6
                    className="text-primary fw-800 small uppercase"
                    style={{ letterSpacing: "1px" }}
                  >
                    Kepemilikan Jaminan
                  </h6>
                  <hr className="mt-1" />
                </Col>
                <InfoItem
                  label="Status Pemilik"
                  value={getLabel(
                    "pemilikJaminan",
                    valDetail.stepLima.pemilikJaminan,
                  )}
                />
                <InfoItem
                  label="Nama Pemilik di Dokumen"
                  value={valDetail.stepLima.namaPemilikJaminan}
                />
                <InfoItem
                  label="No. HP Pemilik"
                  value={valDetail.stepLima.noHpPemilikJaminan}
                  color="#116D6E"
                />
              </Row>
            </div>
          </Card.Body>
        </Card>
      </Col>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar { width: 4px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: #f1f1f1; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e0; border-radius: 10px; }
        .fw-800 { font-weight: 800; }
      `}</style>
    </Row>
  );
}

export default Step5;
